export default "__VITE_ASSET__CqwYpclV__"